var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22907_40558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.75163 2H3.16663C2.61663 2 2.16663 2.45 2.16663 3V10C2.16663 10.55 2.61663 11 3.16663 11H10.1666C10.7166 11 11.1666 10.55 11.1666 10V5.415C11.1666 5.15 11.0616 4.895 10.8716 4.71L8.45663 2.295C8.27163 2.105 8.01663 2 7.75163 2ZM4.66663 8H8.66663C8.94163 8 9.16663 8.225 9.16663 8.5C9.16663 8.775 8.94163 9 8.66663 9H4.66663C4.39163 9 4.16663 8.775 4.16663 8.5C4.16663 8.225 4.39163 8 4.66663 8ZM4.66663 6H8.66663C8.94163 6 9.16663 6.225 9.16663 6.5C9.16663 6.775 8.94163 7 8.66663 7H4.66663C4.39163 7 4.16663 6.775 4.16663 6.5C4.16663 6.225 4.39163 6 4.66663 6ZM4.66663 4H7.16663C7.44163 4 7.66663 4.225 7.66663 4.5C7.66663 4.775 7.44163 5 7.16663 5H4.66663C4.39163 5 4.16663 4.775 4.16663 4.5C4.16663 4.225 4.39163 4 4.66663 4Z",
    fill: "#94A3B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22907_40558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.666626 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressfile);
export default __webpack_public_path__ + "static/media/progressfile.d7838d2320ba0f1e770b004259042bcb.svg";
export { ForwardRef as ReactComponent };